'use strict';

const videoBlock = {
    // Init empty array of iframe data, one array from each video
    iframeCtn: [],
    // Init empty array of iframe YT objects for use elsewhere
    // Use this to iterate through and pause all videos when
    // another begins playing
    iframeObjects: [],
    mediaList: [],
    popin: document.querySelector('.bVideo_popin'),
    popinClose: document.querySelector('.bVideo_popin-close'),
    init: function () {
        let _this = this;

        // For each iframe you find, add its ID to the iframeIds array
        let iframes = document.querySelectorAll(".bVideo .bVideo_video");
        iframes.forEach(function (iframe) {
            // console.log(iframe.dataset);
            setTimeout(function () {
                let data = [
                    iframe.id
                ];
                _this.iframeCtn.push(data);
            }, 500);
        });
        _this.event();
    },
    event: function () {
        if (videoBlock.popinClose) {
            videoBlock.popinClose.addEventListener('click', function () {
                videoBlock.closePopin(this);
            });
        }
    },
    // 3. This function creates an <iframe> (and YouTube player)
    //    after the API code downloads.
    onYouTubeIframeAPIReady: function () {
        let _this = videoBlock;

        _this.iframeCtn.forEach(function (iframeData) {
            let videoId = iframeData[0];
            let playerVars = {
                'rel': 0,
                'showinfo': 0,
                'controls': 1,
                'playsinline': 1
            }
            _this.player = new YT.Player(videoId, {
                host: 'https://www.youtube.com',
                width: '640',
                height: '360',
                videoId: videoId,
                playerVars: playerVars,
                events: {
                    'onReady': videoBlock.onPlayerReady,
                    'onStateChange': videoBlock.onPlayerStateChange
                },
            });
        });
    },

    onPlayerReady: function (event) {
        let _this = videoBlock;

        let iframeObject = event.target;
        let iframeElement = event.target.getIframe();
        let videoContainer = iframeElement.parentElement.parentElement;

        videoContainer.querySelector('.bVideo_media .btn_play').style.display = "block";
        videoContainer.querySelector('.bVideo_media .btn_play').style.opacity = "1";

        let buttonPlay = videoContainer.querySelector('.btn_play');

        // Push current iframe object to array
        _this.iframeObjects.push(iframeObject);

        buttonPlay.addEventListener('click', function () {
            // Pause all videos currently playing
            _this.iframeObjects.forEach(function (scopediframeObject) {
                scopediframeObject.pauseVideo();
                let scopediframeElement = scopediframeObject.getIframe().closest('.bVideo');
                scopediframeElement.classList.remove('played');
            });

            videoBlock.openPopin(this);
        });

        buttonPlay.addEventListener('touchend', function () {
            // Pause all videos currently playing
            _this.iframeObjects.forEach(function (scopediframeObject) {
                scopediframeObject.pauseVideo();
                let scopediframeElement = scopediframeObject.a.closest('.bVideo');
                scopediframeElement.classList.remove('played');
            });

            videoBlock.openPopin(this);
        });


        let stopVideo = videoContainer.querySelector('.stopVideo');
        stopVideo.addEventListener('click', function () {
            iframeObject.stopVideo();
        });
    },

    onPlayerStateChange: function (evt) {
        var state = event.data;
        switch (state) {
            case YT.PlayerState.ENDED:
                videoBlock.closePopin();
                break;

            case YT.PlayerState.PLAYING:
            case YT.PlayerState.BUFFERING:
            case YT.PlayerState.PAUSED:
            case YT.PlayerState.CUED:
            default:
        }
    },
    openPopin: function (element) {
        let src = element.parentNode.querySelector('iframe').src;
        videoBlock.popin.querySelector('.bVideo_popin-content').innerHTML = '<iframe id="bVideoIframeYoutube" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; playinline; encrypted-media; gyroscope; picture-in-picture" title="YouTube video player" width="100%" height="100%" src="' + src + '&autoplay=1&playsinline=1"></iframe>';
        videoBlock.popin.classList.add('visible');
    },
    closePopin: function () {
        videoBlock.popin.classList.remove('visible');
        videoBlock.popin.querySelector('.bVideo_popin-content').innerHTML = "";
    }
};


export default videoBlock;



// WEBPACK FOOTER //
// ./src/scripts/components/videoBlock.js